/* eslint-disable */
import * as React from "react";
const Filter_Icon = ({ color }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    viewBox="0 0 32 32"
  >
    <path d="m12 25 6.67 6.67a1 1 0 0 0 .7.29.91.91 0 0 0 .39-.08 1 1 0 0 0 .61-.92V13.08L31.71 1.71a1 1 0 0 0 .21-1.09A1 1 0 0 0 31 0H1a1 1 0 0 0-.92.62 1 1 0 0 0 .21 1.09l11.38 11.37v11.25A1 1 0 0 0 12 25ZM3.41 2h25.18l-10 10a1 1 0 0 0-.3.71v15.88l-4.66-4.67V12.67a1 1 0 0 0-.3-.71Z" />
  </svg>
);
export default Filter_Icon;
